/**
 * `@4f/ui` errors. Presentation-layer failures — a hook used outside its
 * provider, or a formatter handed an unusable value. Every error extends the
 * shared {@link AppError} so callers branch on a stable `code` (never a bare
 * `Error`).
 */
import { AppError } from '@4f/shared';

/** Thrown when a context hook (e.g. `useTheme`) runs outside its provider. */
export class MissingProviderError extends AppError {
  readonly code = 'ui_missing_provider';
  constructor(hook: string, provider: string) {
    super(`${hook}() must be called inside a <${provider}>.`, { statusCode: 500 });
  }
}

/** Thrown when the datetime formatter receives an unparseable value. */
export class InvalidDateError extends AppError {
  readonly code = 'ui_invalid_date';
  constructor(value: unknown) {
    super(`Cannot format an invalid date: ${JSON.stringify(value)}.`, { statusCode: 400 });
  }
}

/** Thrown when the hCaptcha vendor script cannot be loaded or installs no api. */
export class CaptchaLoadError extends AppError {
  readonly code = 'ui_captcha_load_failed';
  constructor(reason: string) {
    super(`Cannot render the captcha: ${reason}.`, { statusCode: 503 });
  }
}
